import React from "react";
import ComplianceLock from "@/components/compliance/ComplianceLock";
import UserPreferenceSetup from "@/components/personalization/UserPreferenceSetup";
import Logix2PersonalRelationshipPanel from "@/components/personalization/Logix2PersonalRelationshipPanel";
import { usePersonalization } from "@/components/personalization/PersonalizationContext";
import { PALETTE } from "@/components/animation/MotionShared";

/**
 * OraclePersonalizationEngine — wraps the preference setup + relationship
 * panel into a single section the home page can mount inline (additive).
 *
 * For guests, only the relationship panel renders with its sign-in CTA.
 */
export default function OraclePersonalizationEngine({ testid = "oracle-personalization-engine" } = {}) {
  const { isAuthed } = usePersonalization();
  return (
    <section style={S.shell} data-testid={testid}>
      <header style={S.head}>
        <div>
          <span style={S.tagline}>Phase 31 · ORACLE Personal Intelligence Layer™</span>
          <h3 style={S.title}>Your personalized market companion</h3>
        </div>
      </header>
      <ComplianceLock variant="inline" short policy="v27" testid={`${testid}-compliance-top`} />

      <Logix2PersonalRelationshipPanel testid={`${testid}-relationship`} limit={6} />

      {isAuthed && <UserPreferenceSetup asModal={false} testid={`${testid}-preferences`} />}
    </section>
  );
}

const S = {
  shell: { background: "transparent", display: "flex", flexDirection: "column", gap: 12, minWidth: 0, maxWidth: "100%", boxSizing: "border-box" },
  head: { display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, flexWrap: "wrap" },
  tagline: { color: PALETTE.gold, fontFamily: "'Space Mono', monospace", fontSize: 10.5, letterSpacing: "0.18em" },
  title: { color: PALETTE.goldBright, margin: 0, fontSize: 16 },
};
